import React from 'react';
import { Facebook, Instagram, Youtube } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#084A70] text-white/80 py-12 border-t border-white/10" data-id="element-127">
      <div className="container mx-auto px-4" data-id="element-128">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-129">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1" data-id="element-130">
            <a href="#" className="inline-block mb-6" data-id="element-131">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/m3nP7fc9XV1ZSHtYcih2QJ/Beach_Club_Logo.png" alt="Beach Club Logo" className="h-20 w-20 object-cover rounded-full border-2 border-white/20" data-id="element-132" />
            </a>
            <p className="text-sm leading-relaxed mb-6" data-id="element-133">
              מועדון הגלישה והחתירה המוביל בכנרת. מקצועיות, בטיחות ואהבה לים הם
              הערכים שמובילים אותנו.
            </p>
            <div className="flex gap-4" data-id="element-134">
              <a href="#" className="hover:text-white transition-colors bg-white/5 p-2 rounded-full hover:bg-white/20" data-id="element-135">
                <Facebook className="w-5 h-5" data-id="element-136" />
              </a>
              <a href="#" className="hover:text-white transition-colors bg-white/5 p-2 rounded-full hover:bg-white/20" data-id="element-137">
                <Instagram className="w-5 h-5" data-id="element-138" />
              </a>
              <a href="#" className="hover:text-white transition-colors bg-white/5 p-2 rounded-full hover:bg-white/20" data-id="element-139">
                <Youtube className="w-5 h-5" data-id="element-140" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div data-id="element-141">
            <h4 className="text-white font-bold mb-6" data-id="element-142">ניווט מהיר</h4>
            <ul className="space-y-3 text-sm" data-id="element-143">
              <li data-id="element-144">
                <a href="/" className="hover:text-white transition-colors" data-id="element-145">
                  דף הבית
                </a>
              </li>
              <li data-id="element-146">
                <a href="/sup" className="hover:text-white transition-colors" data-id="element-147">
                  SUP
                </a>
              </li>
              <li data-id="element-148">
                <a href="/sup-race" className="hover:text-white transition-colors" data-id="element-149">
                  SUP Race
                </a>
              </li>
              <li data-id="element-150">
                <a href="/sup-tours" className="hover:text-white transition-colors" data-id="element-151">
                  טיולי סאפ
                </a>
              </li>
              <li data-id="element-152">
                <a href="/surfski" className="hover:text-white transition-colors" data-id="element-153">
                  קיאק Surfski
                </a>
              </li>
              <li data-id="element-154">
                <a href="/wingfoil" className="hover:text-white transition-colors" data-id="element-155">
                  Wing Foil
                </a>
              </li>
              <li data-id="element-156">
                <a href="/events" className="hover:text-white transition-colors" data-id="element-157">
                  אירועים וסדנאות
                </a>
              </li>
              <li data-id="element-158">
                <a href="/#contact" className="hover:text-white transition-colors" data-id="element-159">
                  צור קשר
                </a>
              </li>
            </ul>
          </div>

          {/* Activities */}
          <div data-id="element-160">
            <h4 className="text-white font-bold mb-6" data-id="element-161">פעילויות</h4>
            <ul className="space-y-3 text-sm" data-id="element-162">
              <li data-id="element-163">
                <a href="#" className="hover:text-white transition-colors" data-id="element-164">
                  שיעורי גלישה
                </a>
              </li>
              <li data-id="element-165">
                <a href="#" className="hover:text-white transition-colors" data-id="element-166">
                  השכרת ציוד
                </a>
              </li>
              <li data-id="element-167">
                <a href="#" className="hover:text-white transition-colors" data-id="element-168">
                  קבוצות חתירה
                </a>
              </li>
              <li data-id="element-169">
                <a href="#" className="hover:text-white transition-colors" data-id="element-170">
                  אירועים פרטיים
                </a>
              </li>
              <li data-id="element-171">
                <a href="#" className="hover:text-white transition-colors" data-id="element-172">
                  ימי גיבוש
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div data-id="element-173">
            <h4 className="text-white font-bold mb-6" data-id="element-174">הישארו מעודכנים</h4>
            <p className="text-sm mb-4" data-id="element-175">
              הירשמו לניוזלטר שלנו לקבלת עדכונים על אירועים ומבצעים
            </p>
            <form className="flex gap-2" data-id="element-176">
              <input type="email" placeholder="האימייל שלך" className="bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-sm text-white placeholder-white/50 focus:outline-none focus:border-white w-full" data-id="element-177" />
              <button className="bg-white text-[#084A70] px-4 py-2 rounded-lg text-sm font-bold hover:bg-blue-50 transition-colors" data-id="element-178">
                שלח
              </button>
            </form>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8" data-id="element-179">
          <div className="text-center text-xs" data-id="element-180">
            <p data-id="element-181">
              &copy; {new Date().getFullYear()} Beach Club Maagan Eden. כל
              הזכויות שמורות.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}